<template>
    <zone
        auto-height
        align="center"
        class="app"
        contrast="light"
        :background-image="images.background"
        :data-label="dico.dataLabel"
        :id="dico.id"
        v-if="isDisplayed"
    >
        <heading :level="2" v-html="dico.title" />
        <paragraph :size="sizes.introduction" :content="dico.introduction" />
        <section class="machine">
            <visual class="front" :src="images.front" />
            <visual class="quarter" :src="images.quarter" />
        </section>
        <paragraph class="legend" size="XL" :content="dico.legend" />
        <paragraph :size="sizes.text" :content="dico.text" />

    </zone>
</template>

<script>
import Heading from 'gvue/src/core/Heading'
import Paragraph from 'gvue/src/core/Paragraph'
import Visual from 'gvue/src/core/Visual'
import Zone from 'gvue/src/core/Zone'

import { getBackground, getVisual } from '@/helpers/visual'

export default {
    name: 'SectionDispenser',
    components: {
        Heading,
        Paragraph,
        Visual,
        Zone
    },
    created () {
        this.dico = this.$json.app
    },
    computed: {
        isDisplayed () {
            return this.dico.display
        },
        images () {
            const { visuals } = this.dico
            return {
                background: this.$breakpoint.isS ? null : getBackground(this.dico.background),
                front: getVisual(visuals.front),
                quarter: getVisual(visuals.quarter)
            }
        },
        sizes () {
            return {
                introduction: this.$breakpoint.isS ? 'L' : 'XL',
                text: this.$breakpoint.isS ? 'M' : 'L'
            }
        }
    }
}
</script>

<style lang="sass" scoped>
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables
.app
    background-color: $color_background

.legend
    text-transform: uppercase

/deep/
    .g_bg
        background-size: cover

+mobile

    .machine
        margin-top: ($gap * 3)

        > .g_visual
            display: block
            max-height: pxToRem(380)
            max-width: pxToRem(340)
            margin-right: auto
            margin-left: auto

    .quarter
        margin-top: -15%
        margin-bottom: ($gap * -2)

    .g
        .g_center .g_text
            > .g_btn
                margin-top: ($gap * 2)
                width: 100%

+desktop
    .machine
        display: flex
        justify-content: center
        margin-top: ($gap * 5)
        margin-bottom: ($gap * -8)

        > .g_visual
            max-height: pxToRem(562)
            max-width: 100%

    .front
        margin-left: -3.5em

    .quarter
        margin-top: -1em
        margin-left: -3em

    .g
        .g_center .g_text
            > .g_h2
                width: 90%

            > .g_txt_XL
                width: 70%

            > .g_txt_L
                width: 60%

            > .g_btn
                margin-top: ($gap * 3)

@media screen and (min-width: 768px) and (max-width: 1200px)
    .quarter
        margin-left: -9em

</style>
